module.exports = __webpack_public_path__ + "img/dy.b743cd99.png";